import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=b4b7914a&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4b7914a')) {
      api.createRecord('b4b7914a', component.options)
    } else {
      api.reload('b4b7914a', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=b4b7914a&", function () {
      api.rerender('b4b7914a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-225bN8qqTdXRX/JS/comp/ImgFallback2.vue"
export default component.exports